@if (isValidDate) {
  <mat-card appearance="outlined" class="committee-header">
    <mat-card-title> {{ formattedDate }} Committee Dashboard </mat-card-title>
  </mat-card>
}
<br />
<embedded-report>
@if (info.length > 0) {
  <div>
    @for (committee of info; track committee; let index = $index) {
      <mat-card
        appearance="outlined"
      class="committee-cards {{
        committee.committeeName.split(' ').join('-').toLowerCase()
      }}">
        <mat-card-title class="committee-title">
          <div class="row align-top info-container">
            <div class="col-md-4">
              <b>
                {{ committee.projectName }}
              </b>
            </div>
            <div class="col-10 col-md-4 committee-name">
              <span>{{ committee.committeeName }}</span>
            </div>
            <div class="col-2 col-md-4 button-container">
              <button
                class="expand-section"
                [ngClass]="committee.expand ? 'expand' : 'collapse'"
                (click)="rotate(index)">
                <mat-icon>expand_more</mat-icon>
              </button>
            </div>
            <div class="col-md-12">
              <small class="status"
                ><b>CURRENT STATUS: </b>{{ committee.projectStatus }}</small
                >
              </div>
            </div>
          </mat-card-title>
          <mat-card-content
            class="deal-card">
            @if(committee.expand){
              <app-committee-deal-information
              [deal]="committee"></app-committee-deal-information>
              <app-committee-deal-dates [deal]="committee"></app-committee-deal-dates>
              <hr />
              <committee-reports
                [projectId]="committee.project.id"
              [project]="committee.project"></committee-reports>
              <app-committee-links
                [deal]="committee"
                [readOnly]="committee.readOnly"
              [milestones]="milestones"></app-committee-links>
              <app-committee-conditions
                [projectId]="committee.project.id"
                [readOnly]="committee.readOnly"
                [milestones]="milestones"
              [approvalType]="getLegalApprovalType()"></app-committee-conditions>
              @for (milestone of milestones; track milestone) {
                <app-milestone-sections
                  [milestone]="milestone"
            [disclosure]="
              getDisclosureForMilestone(
                committee.disclosures,
                committee.project,
                milestone
              )
            "
                  [milestones]="milestones"
                  [currentMilestone]="committee.milestone"
                  [approvalTypes]="approvalTypes"
                  [readOnly]="committee.readOnly"
                [project]="committee.project"></app-milestone-sections>
              }
              @for (milestone of milestones; track milestone) {
                <app-disclosures-editor
                  (updateHTML)="receiveEditorHTML($event, index)"
                  [milestone]="milestone"
                  [currentMilestone]="committee.milestone"
                  [readOnly]="committee.readOnly"
                  [project]="committee.project"
            [disclosure]="
              getDisclosureForMilestone(
                committee.disclosures,
                committee.project,
                milestone
              )
            "></app-disclosures-editor>
              }
              <app-committee-conditions
                title="LEGAL NOTES"
                [projectId]="committee.project.id"
                [approvalType]="getLegalApprovalType()"
                [isLegalNote]="true"
                [readOnly]="committee.readOnly"
                [milestones]="milestones"
            [headerColumns]="[
              'issue',
              'milestone',
              'actions'
            ]"></app-committee-conditions>
            }
          </mat-card-content>
        </mat-card>
      }
    </div>
  }
  @if (!waiting && info.length === 0) {
    <div>
      <h3>There are no committees on this date.</h3>
    </div>
  }
</embedded-report>
